<build-section
  [disabled]="disabled"
  [title]="question">
  <div class="mb-2"
       *ngIf="price !== undefined && price > 0">
    <span
      [translate]="'cakeBuilder.cakeQuestionSection.cost'"></span>&nbsp;<span>{{price | currencyFormat}} {{currency}}</span>
  </div>

  <div class="form-group mb-2">
    <ui-expandable-textarea
      [placeholder]="'common.textareaPlaceholder' | translate"
      [(model)]="answer"
      [rows]="1"
      [maxLength]="maxLength"
      [allowEmoji]="false"
      (modelChange)="answerChanged$.next($event)">
    </ui-expandable-textarea>
  </div>
  <div class="fw-bold font-sm">
    {{ 'common.limitLetters' | translate:{"length": textLength, "maxLength": maxLength} }}
  </div>
  <div class="help-text" *ngIf="helpText">
    {{helpText}}
  </div>
</build-section>
